import { chunkArray } from 'src/app/common/list';

/** Max emails per invitations/bulk request. */
export const BULK_INVITE_BATCH_SIZE = 200;

/**
 * Splits invite emails into API-safe batches for bulk invite.
 * Lists of {@link BULK_INVITE_BATCH_SIZE} or fewer stay as a single batch (existing behavior).
 */
export function splitIntoBulkInviteBatches<T>(items: T[]): T[][] {
  if (items.length <= BULK_INVITE_BATCH_SIZE) {
    return [items];
  }
  return chunkArray(items, BULK_INVITE_BATCH_SIZE);
}
